import { memo } from "react";
import DashboardContent from "./DashboardContent";
import { TemplatePage } from "../0_TemplatePage/TemplatePage";
// import { useAppContext } from "../../8_contexts/appContext";
// import DashboardContentMobile from "./DashboardHelpers/DashboardContentMobile";

function Dashboard() {
  // const {isMobile} = useAppContext()
  return (
    <div className="content" sx={{ clear: "left" }}>
      <TemplatePage type={"dashboard"}>
        <DashboardContent />
      </TemplatePage>
    </div>
  );
}

export default memo(Dashboard);
